import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';
import { ReimbursedProduct } from '@queries/userInsurance/queries/getInsuranceQuote';

export const SeparateOrderDetailsByInsurance = () => gql`
  mutation SeparateOrderDetailsByInsurance(
    $params: SeparateOrderDetailsByInsuranceParams
  ) {
    separateOrderDetailsByInsurance(params: $params) {
      deliveryDate
      deliveryType
      deliveryCost
      orderDetails {
        quantity
        insurance {
          unitReimbursement
          unitCopay
          unitDeductible
        }
        type
        listPrice
        product {
          id
          name
          imagesUrl
          activePrinciple
          concentration
          unit
          prescriptionType
          quantity
          format
          price
          container
          containerQuantity
          laboratory
          availability {
            stock
            statusWithoutStock
            status
          }
          discount {
            type
            price
            listPrice
          }
        }
        price
      }
    }
  }
`;

export type SeparateOrderDetailsByInsuranceParams = ResolverParams<{
  orders: Order[];
  reimbursedProducts: ReimbursedProduct[];
}>;

export type SeparateOrderDetailsByInsuranceResponse = {
  separateOrderDetailsByInsurance: Order[];
};
